import styled from "styled-components";
import {StyledModal} from "../../../common/shared/modal.styled";

export const StyledStopPlansModal = styled(StyledModal)`
  .modal-header {
    color: var(--bllink-gray);
  }
  .modal-dialog .modal-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 10px;
    color: var(--bllink-gray);

    .confirm {
      margin: 10px 0;
    }

    button {
      width: 200px;
      margin-top: 42px;
    }

    th {
      padding: 10px .5em;
      min-width: 100px;
      &.amount {
        text-align: end;
      }
      &:first-of-type {
        min-width: 0;
      }
    }

    td {
      padding-bottom: 13px;
      padding-inline-end: 0.5em;
      padding-inline-start: 0.5em;
      &.amount {
        text-align: end;
      }
      &:first-of-type {
        padding-bottom: 0;
      }
    }
  }
`
